import { s, c, t, nextAppRouter } from '../../../../val.config';

export const eventSchema = s.object({
  title: s.string(),
  type: s.union(s.literal('party'), s.literal('presentation')),
  date: s.datetime(),
  introduction: s.richtext({
    bold: true,
    italic: true,
    lineThrough: true,
    h1: true,
    h2: true,
    h3: true,
    h4: true,
    h5: true,
    h6: true,
    ul: true,
    ol: true,
    a: true,
    img: true,
  }),
  metadataDescription: s.string().nullable(),
  metadataTitle: s.string().nullable(),
  main: s.richtext({
    bold: true,
    italic: true,
    lineThrough: true,
    h1: true,
    h2: true,
    h3: true,
    h4: true,
    h5: true,
    h6: true,
    ul: true,
    ol: true,
    a: true,
    img: true,
  }),
  eventFull: s.boolean(),
  eventImage: s.image(),
  location: s.object({
    address: s.richtext({
      bold: true,
      italic: true,
      lineThrough: true,
      h1: true,
      h2: true,
      h3: true,
      h4: true,
      h5: true,
      h6: true,
      ul: true,
      ol: true,
      a: true,
      img: true,
    }),
    nameOfLocation: s.string(),
  }),
  program: s.array(
    s.object({
      description: s.string(),
      time: s.string().raw(),
    })
  ),
  typeformId: s.string().nullable(),
  signup: s
    .object({
      url: s.string(),
      opens: s.date().nullable(),
    })
    .nullable(),
  speakers: s.array(
    s.object({
      name: s.string(),
      roles: s.array(s.string()).nullable(),
      speakerImage: s.image(),
    })
  ),
  eventbriteEventId: s.number().nullable(),
  eventbriteUrl: s.string().nullable(),
});
export type Event = t.inferSchema<typeof eventSchema>;
export const schema = s.router(nextAppRouter, eventSchema);

export default c.define('/app/(main)/events/[slug]/page.val.ts', schema, {
  '/events/no-code': {
    date: `2023-09-01T06:00:00.000Z`,
    type: 'presentation',
    eventFull: false,
    eventImage: {
      path: '/public/val/images/5a678d1dfb4557ed5fc7ee4dd9535a62a332a751-2500x1429.webp',
      width: 2500,
      height: 1429,
      mimeType: 'image/webp',
    },
    introduction: [
      {
        tag: 'p',
        children: [
          "No-code eller low-code har på få år gått fra å være entusiastbegreper til å være noe alle CTOer og CDOer har på leppene. Selveste Chris Wanstrath, grunnlegger og tidligere CEO i Github, hevder at fremtiden til kode er ingen kode i det hele tatt. Men hva er no-code? What's the catch? Og når bør det brukes? Bli med på et foredrag med ",
          {
            tag: 'a',
            href: 'https://www.appfarm.io/',
            children: ['Appfarm'],
          },
          ' - en norskutviklet "fullstack" no-code plattform. Foredraget skal gi deg overblikk og innsikt i teknologien og muligheter, inkludert når man bør bruke no-code som alternativ til kode eller hyllevare. Det blir også en kort demo av selve plattformen.',
        ],
      },
    ],
    location: {
      address: [
        {
          tag: 'p',
          children: [
            {
              tag: 'a',
              href: 'https://goo.gl/maps/GLURauoXQKKWPB9S8',
              children: ['Torggata 15, 0971 Oslo'],
            },
          ],
        },
      ],
      nameOfLocation: `Blank, Torggata 15`,
    },
    main: [
      {
        tag: 'p',
        children: [
          'Kristian har jobbet med no-code i 14 år - både som utvikler, arkitekt, designer og prosjektleder. Han var med å starte ',
          {
            tag: 'a',
            href: 'https://www.appfarm.io/',
            children: ['Appfarm'],
          },
          ' for litt over 5 år siden, og jobber i dag med uviklerverktøyet Appfarm Create, utvikleropplevelsen og opplæring.',
        ],
      },
    ],
    program: [
      { description: `Croissanter og kaffe`, time: `0800` },
      { description: `Kristian snakker`, time: `0830` },
      { description: `Q&A`, time: `0915` },
      { description: `Mer kaffe?`, time: `0930` },
      { description: `Dørene lukkes`, time: `1000` },
    ],
    typeformId: null,
    signup: {
      url: `https://www.eventbrite.com/e/705968459667?aff=oddtdtcreator`,
      opens: `2023-08-25T06:08:00.000Z`,
    },
    speakers: [
      {
        name: `Kristian Mella`,
        roles: [`Appfarm - VP Product Ecosystem`],
        speakerImage: {
          path: '/public/val/images/e76173f4367e9c5dbba28c6c903d7e4590f66ba1-2362x3150.webp',
          width: 2362,
          height: 3150,
          mimeType: 'image/webp',
        },
      },
    ],
    title: `"The future of coding is no coding at all"`,
    eventbriteEventId: null,
    eventbriteUrl: null,
    metadataDescription: null,
    metadataTitle: null,
  },
  '/events/amoi': {
    date: `2023-06-02T06:00:00.000Z`,
    type: 'presentation',
    eventFull: false,
    eventImage: {
      path: '/public/val/images/38f9b2794fd646bf2f7cb8c0941f1a0521b513ee-4756x2042.webp',
      width: 4756,
      height: 2042,
      mimeType: 'image/webp',
    },
    introduction: [
      {
        tag: 'p',
        children: [
          'How does one of the oldest companies in Norway transition into the 21st century? 3 years ago, we began working together with a small startup team of seven in Posten’s innovation hub to help answer that very question. We will share what it’s been like to build AMOI (amoi.no) from strategy, to sketch to pilot, and from pilot to launch and now growth. You will get an insight into how we have gone about building an agile new brand and service in a start-up team. And hear about our focus on building a service that seeks to benefit people, partners and be profitable for Posten.',
        ],
      },
    ],
    location: {
      address: [
        {
          tag: 'p',
          children: [
            {
              tag: 'a',
              href: 'https://goo.gl/maps/GLURauoXQKKWPB9S8',
              children: ['Torggata 15, 0971 Oslo'],
            },
          ],
        },
      ],
      nameOfLocation: `Blank`,
    },
    main: [
      {
        tag: 'p',
        children: [
          'Lee is an experienced designer with over 15 years experience working on UX, branding and strategy. He has extensive experience in designing robust, user-focused digital interfaces. Lee has worked for many major Norwegian clients most recently winning awards for his work for hip-hop artist Karpe and with AMOI.',
        ],
      },
      {
        tag: 'p',
        children: [
          'Jimmy is the CEO and founder of AMOI and part of the Posten Group. Jimmy has been on the AMOI journey since start from idea to implementation and has the overall responsibility for the business.',
        ],
      },
    ],
    program: [
      { description: `Croissanter og kaffe`, time: `0800` },
      { description: `Lee og Jimmy snakker`, time: `0830` },
      { description: `Q&A`, time: `0915` },
      { description: `Mer kaffe?`, time: `0930` },
      { description: `Dørene lukkes`, time: `1000` },
    ],
    typeformId: null,
    signup: {
      url: `https://www.eventbrite.com/e/kjregar-004-how-a-potato-can-help-create-an-e-commerce-startup-amoi-tickets-632542841667`,
      opens: `2023-05-08T12:44:00.000Z`,
    },
    speakers: [
      {
        name: `Lee Frost`,
        roles: [`Fagleder for Design`],
        speakerImage: {
          path: '/public/val/images/a82d6c4f6c961c7119adba753296897687b05873-1007x1007.webp',
          width: 1007,
          height: 1007,
          mimeType: 'image/webp',
        },
      },
      {
        name: `Jimmy Rhodin`,
        roles: [`CEO of AMOI`],
        speakerImage: {
          path: '/public/val/images/22b594b715e02423523d4f4a44281f1d36ceafb0-1477x1476.webp',
          width: 1477,
          height: 1476,
          mimeType: 'image/webp',
        },
      },
    ],
    title: `AMOI: Building a Digital Marketplace from Scratch`,
    eventbriteEventId: 639219521797,
    eventbriteUrl: `https://www.eventbrite.com/e/aasdasdasd-tickets-639219521797`,
    metadataDescription: null,
    metadataTitle: null,
  },
  '/events/ai-tekst-og-bildegenerering': {
    date: `2023-03-24T07:00:00.000Z`,
    type: 'presentation',
    eventFull: false,
    eventImage: {
      path: '/public/val/images/ce394523806509a98f4b240c64fa75e88fce1c00-1704x1704.webp',
      width: 1704,
      height: 1704,
      mimeType: 'image/webp',
    },
    introduction: [
      {
        tag: 'p',
        children: [
          'Er du nysgjerrig på open source-alternativer til Dall-E og ChatGPT?',
        ],
      },
      {
        tag: 'p',
        children: [
          'Vi ser på noen helt åpne alternativer til de mest populære og kommersielle AI for tekst (GPT-3 og ChatGPT) og bildegenerering (DALL-E). Foredraget fokuserer på hvordan man ta i bruk helt åpne modeller på maskinvare man styrer selv.',
        ],
      },
      {
        tag: 'p',
        children: [
          'Alt som vises er 100% open source og kan kjøres på ordinær high-end maskinvare tilgjengelig i butikken på hjørnet.',
        ],
      },
      {
        tag: 'p',
        children: [
          'Det blir praktisk oppsett og små kodedemoer med fokus på å senke terskelen for at flere utviklere og designere sammen begynner å utforske og bygge løsninger med AI uten de kommersielle avhengighetene.',
        ],
      },
      {
        tag: 'p',
        children: [
          'Foredraget passer til alle nybegynnere innen maskinlæring eller de som er nysgjerrige på hvordan man kan ta i bruk åpne modeller på maskinvare man styrer selv.',
        ],
      },
      {
        tag: 'p',
        children: [
          'Det er en stor fordel hvis man er komfortabel med utviklerverktøy og kan kode litt, men dette er ikke et absolutt krav siden vi prøver å forklare alt vi gjør underveis.',
        ],
      },
      { tag: 'p', children: ['Vi sees!'] },
      {
        tag: 'p',
        children: [
          '«Kjøregår» er en serie med åpne foredrag hos Blank, og alle som er nysgjerrige er hjertelig velkommen. Begrenset antall plasser.',
        ],
      },
    ],
    location: {
      address: [
        {
          tag: 'p',
          children: [
            {
              tag: 'a',
              href: 'https://goo.gl/maps/GLURauoXQKKWPB9S8',
              children: ['Torggata 15, 0971 Oslo'],
            },
          ],
        },
      ],
      nameOfLocation: `Blank, Torggata 15`,
    },
    main: [
      {
        tag: 'p',
        children: [
          'Fremveksten av kunstig intelligens på alle kanter både forbløffer og forferder oss. Som erfaren utvikler er Andreas mest gira og ivrig på å finne svar på hvordan og hva vi kan bruke den til. I dag. Kom og hør Andreas dele litt om hvordan man kommer i gang med åpne alternativer til de kommersielle løsningene bak API og betalingsmur.',
        ],
      },
      { tag: 'p', children: ['Zero API tokens required!'] },
    ],
    program: [
      { description: `Croissanter og kaffe`, time: `0800` },
      { description: `Andreas snakker og viser`, time: `0830` },
      { description: `Q&A`, time: `0915` },
      { description: `Mer kaffe?`, time: `0930` },
      { description: `Dørene lukkes`, time: `1000` },
    ],
    typeformId: null,
    signup: { url: `https://kjoregar003.eventbrite.com`, opens: null },
    speakers: [
      {
        name: `Andreas Rudi Søvik`,
        roles: [`Erfaren teknolog i Blank`],
        speakerImage: {
          path: '/public/val/images/8d71720997e6e0f8348d86e4c9696e60b2333e0c-573x573.webp',
          width: 573,
          height: 573,
          mimeType: 'image/webp',
        },
      },
    ],
    title: `Tekst og bildegenerering med open source AI`,
    eventbriteEventId: null,
    eventbriteUrl: null,
    metadataDescription: null,
    metadataTitle: null,
  },
  '/events/karpe': {
    date: `2022-12-02T07:00:00.000Z`,
    type: 'presentation',
    eventFull: false,
    eventImage: {
      path: '/public/val/images/408ce60647b86bb26604be1b84e51d66e6df99a5-816x795.webp',
      width: 816,
      height: 795,
      mimeType: 'image/webp',
    },
    introduction: [
      {
        tag: 'p',
        children: [
          'Silje Larsen Borgan i management- og kommunikasjonsselskapet Little Big Sister har artister som Karpe, Emilie Nicolas, Cezinando og Gabrielle i stallen.',
        ],
      },
      {
        tag: 'p',
        children: [
          '«Kjøregår» er en serie med åpne foredrag hos Blank, og alle som er nysgjerrige er hjertelig velkommen. Begrensede plasser og påmelding på lenke.',
        ],
      },
    ],
    location: {
      address: [
        {
          tag: 'p',
          children: [
            {
              tag: 'a',
              href: 'https://goo.gl/maps/GLURauoXQKKWPB9S8',
              children: ['Torggata 15, 0971 Oslo'],
            },
          ],
        },
      ],
      nameOfLocation: `Blank, Torggata 15`,
    },
    main: [
      {
        tag: 'p',
        children: [
          'Fredag 2. desember kommer Silje på besøk til Blank for å fortelle om hvordan Karpe jobbet for å utvikle og gjennomføre konsertene i Skien og Spektrum.Vi får også høre om hvordan LBS og Karpe jobbet med Blank for å lage påmeldingsløsningen til Skien-konsertene.',
        ],
      },
    ],
    program: [
      { description: `Dørene åpner`, time: `0800` },
      { description: `Silje og SAS Skien, og mingling`, time: `0830` },
      { description: `Besøkende kastes ut`, time: `1000` },
    ],
    typeformId: null,
    signup: { url: `https://www.blank.no`, opens: null },
    speakers: [
      {
        name: `Silje Larsen Borgan`,
        roles: [`Manager for Karpe, Emilie Nicolas, Cezinando og Gabrielle`],
        speakerImage: {
          path: '/public/val/images/836e4be17e3b4eb60d439250e4ae1ab2ee84eb40-980x674.webp',
          width: 980,
          height: 674,
          mimeType: 'image/webp',
        },
      },
    ],
    title: `Fra SAS Skien til SAS spektrum`,
    eventbriteEventId: null,
    eventbriteUrl: null,
    metadataDescription: null,
    metadataTitle: null,
  },
  '/events/modyfi': {
    date: `2023-10-13T06:00:00.000Z`,
    type: 'presentation',
    eventFull: true,
    eventImage: {
      path: '/public/val/images/0f4ea116e512da3cc5006840d76e899c6a0029fb-3010x1692.webp',
      width: 3010,
      height: 1692,
      mimeType: 'image/webp',
    },
    introduction: [
      {
        tag: 'p',
        children: [
          'What does the future of graphic design tools look like? Technologies such as computational design and generative AI are changing the landscape of what it means to create visual imagery.',
        ],
      },
      {
        tag: 'p',
        children: [
          'Computational designer Felix Faire (',
          {
            tag: 'a',
            href: 'https://felixfaire.com/',
            children: ['felixfaire.com'],
          },
          ') introduces Modyfi (',
          {
            tag: 'a',
            href: 'https://www.modyfi.com/',
            children: ['modyfi.com'],
          },
          '): a brand new startup building the next generation of collaborative image making tools for artists and designers, and invites all participants to get involved in shaping its future.',
        ],
      },
    ],
    location: {
      address: [
        {
          tag: 'p',
          children: [
            {
              tag: 'a',
              href: 'https://goo.gl/maps/GLURauoXQKKWPB9S8',
              children: ['Torggata 15, 0971 Oslo'],
            },
          ],
        },
      ],
      nameOfLocation: `Blank, Torggata 15`,
    },
    main: [
      {
        tag: 'p',
        children: [
          'Felix Faire is a multidisciplinary computational designer specializing in real-time graphic tools, instruments and experiences. He has previously worked with clients such as Google, Microsoft, Pentagram and Field.io, and is currently leading graphics development at Modyfi, a new startup building the future of collaborative creative tools for artists and designers.',
        ],
      },
    ],
    program: [
      { description: `Croissanter og kaffe`, time: `0800` },
      { description: `Felix prater`, time: `0830` },
      { description: `Q&A`, time: `0915` },
      { description: `Mer kaffe?`, time: `0930` },
      { description: `Dørene lukkes`, time: `1000` },
    ],
    typeformId: null,
    signup: {
      url: `https://www.eventbrite.com/e/kjregar-006-modyfi-future-tools-for-artists-and-designers-tickets-726002391697`,
      opens: `2023-09-22T06:00:00.000Z`,
    },
    speakers: [
      {
        name: `Felix Faire`,
        roles: null,
        speakerImage: {
          path: '/public/val/images/a7dd838019ea24f6dc5f1dd785b60073e0e3692f-640x640.webp',
          width: 640,
          height: 640,
          mimeType: 'image/webp',
        },
      },
    ],
    title: `Future tools for artists and designers `,
    eventbriteEventId: null,
    eventbriteUrl: null,
    metadataDescription: `(﻿The presentation will be given in English)

What does the future of graphic design tools look like? Technologies such as computational design and generative AI are changing the landscape of what it means to create visual imagery. `,
    metadataTitle: `Felix Faire + Modyfi: Future tools for artists and designers `,
  },
  '/events/naar-alt-gaar-galt': {
    date: `2023-02-03T07:00:00.000Z`,
    type: 'presentation',
    eventFull: false,
    eventImage: {
      path: '/public/val/images/b2d9c4e36751d4f8137f1e29b67b784f5b965837-4000x2668.webp',
      width: 4000,
      height: 2668,
      mimeType: 'image/webp',
    },
    introduction: [
      {
        tag: 'p',
        children: [
          'Ida Aalen er forfatter, gründer og produktcoach. Hun skriver for tiden en bok om produktledelse, og hjelper organisasjoner å bli bedre på produktstrategi og -ledelse.',
        ],
      },
      {
        tag: 'p',
        children: [
          '«Kjøregår» er en serie med åpne foredrag hos Blank, og alle som er nysgjerrige er hjertelig velkommen. Begrenset antall plasser',
        ],
      },
    ],
    location: {
      address: [
        {
          tag: 'p',
          children: [
            {
              tag: 'a',
              href: 'https://www.google.com/maps/place/Torggata+15,+0181+Oslo/data=!4m2!3m1!1s0x46416e63c947c01b:0x102ad373936ea426?sa=X&ved=2ahUKEwje3pTA8av9AhUzCBAIHbrjBh0Q8gF6BAgjEAI',
              children: ['Torggata 15, 0181 Oslo'],
            },
          ],
        },
      ],
      nameOfLocation: `Blank, Torggata 15`,
    },
    main: [
      {
        tag: 'p',
        children: [
          'Før hun startet for seg selv var hun i 5 år medgründer og produktsjef i den norske startupen Confrere, som i 2022 ble solgt til Silicon Valley-selskapet Daily.',
        ],
      },
      {
        tag: 'p',
        children: [
          'Etter å ha lest alle de riktige bøkene og sett alle de riktige foredragene klør du sikkert i fingra etter å gjøre alt riktig – noe Ida fikk muligheten til å forsøke i Confrere i 2021. Det pandemi-boostede videoselskapet stod ovenfor en utfordring da verdens kontorer begynte å åpne igjen.',
        ],
      },
      {
        tag: 'p',
        children: [
          'Ida erfarte at du kan gjøre alt riktig, men at det allikevel ikke er nok. «Når det går riktig feil» er et ærlig foredrag om hva som gikk bra, og ikke fullt så bra, da Confrere måtte finne hva de skulle leve av etter korona.',
        ],
      },
    ],
    program: [
      { description: `Frokost`, time: `0800` },
      { description: `«Når det går riktig feil»`, time: `0830` },
      { description: `Q&A`, time: `0915` },
      { description: `Mer kaffe?`, time: `0930` },
      { description: `Dørene lukkes`, time: `1000` },
    ],
    signup: { url: `https://www.blank.no`, opens: null },
    speakers: [
      {
        name: `Ida Aalen`,
        roles: [
          `Produktcoach`,
          `Tidligere medgründer og produktsjef i Confrere`,
        ],
        speakerImage: {
          path: '/public/val/images/b101335fb1d3fded60d52557cf71467bb035dbb5-142x142.webp',
          width: 142,
          height: 142,
          mimeType: 'image/webp',
        },
      },
    ],
    title: `Når det går riktig feil`,
    eventbriteEventId: null,
    eventbriteUrl: null,
    metadataDescription: null,
    metadataTitle: null,
    typeformId: null,
  },
  '/events/byggesakai': {
    date: `2023-12-08T07:00:00.000Z`,
    type: 'presentation',
    typeformId: null,
    eventFull: false,
    eventImage: {
      path: '/public/val/images/267c95fe418574f06f5e06c619689d390ee22437-3600x1884.webp',
      width: 3600,
      height: 1884,
      mimeType: 'image/webp',
    },
    introduction: [
      {
        tag: 'p',
        children: [
          'Alt handler om AI om dagen – men hvor lang er egentlig veien fra å snakke om språkmodeller, til å ta dem i bruk for å effektivisere arbeid? Ikke nødvendigvis veldig lang!',
        ],
      },
      {
        tag: 'p',
        children: [
          'Dario og Cornelia forteller historien om hvordan Blank – i samarbeid med NKF – brukte språkmodeller til å bygge et semantisk søk, for at saksbehandlere kan finne lettere frem i forskrifter og lovdata.',
        ],
      },
      {
        tag: 'p',
        children: [
          {
            tag: 'a',
            href: 'https://byggesak.ai',
            children: ['https://byggesak.ai'],
          },
        ],
      },
      {
        tag: 'p',
        children: [
          {
            tag: 'a',
            href: 'https://www.kommunalteknikk.no/',
            children: ['https://www.kommunalteknikk.no/'],
          },
        ],
      },
    ],
    location: {
      address: [{ tag: 'p', children: ['Torggata 15'] }],
      nameOfLocation: `Blank, Torggata 15`,
    },
    main: [],
    program: [
      { description: `Croissanter og kaffe`, time: `08:00` },
      { description: `Dario og Cornelia prater`, time: `08:30` },
      { description: `Q&A`, time: `09:00` },
      { description: `Mer croissanter og kaffe`, time: `09:15` },
      { description: `Dørene stenger`, time: `10:00` },
    ],
    signup: {
      url: `https://www.eventbrite.com/e/kjregar-007-case-study-byggesakai-tickets-760308502197?aff=oddtdtcreator`,
      opens: `2023-11-16T09:08:00.000Z`,
    },
    speakers: [
      {
        name: `Cornelia Schmitt`,
        roles: [`Designer`],
        speakerImage: {
          path: '/public/val/images/b017beeb99fa98f33e41d4a3680b4ddaa299c928-860x573.webp',
          width: 860,
          height: 573,
          mimeType: 'image/webp',
        },
      },
      {
        name: `Dario Sučić`,
        roles: [`Teknolog`],
        speakerImage: {
          path: '/public/val/images/508a89cc1c2121d547d1956dd25dce1273de3189-860x571.webp',
          width: 860,
          height: 571,
          mimeType: 'image/webp',
        },
      },
    ],
    title: `Case study: byggesak.ai`,
    eventbriteEventId: null,
    eventbriteUrl: null,
    metadataDescription: null,
    metadataTitle: `Case study: byggesak.ai`,
  },
  '/events/hakimaki': {
    date: `2024-01-26T07:00:00.000Z`,
    type: 'presentation',
    eventFull: false,
    eventImage: {
      path: '/public/val/images/4b82fae4e99bade4c324455d30b7efe087a2e1b1-4006x2246.webp',
      width: 4006,
      height: 2246,
      mimeType: 'image/webp',
    },
    introduction: [
      {
        tag: 'p',
        children: [
          'Hakimaki will show how they work from idea to object when making inventions and set pieces in the intersection of design, art and technology.',
        ],
      },
      {
        tag: 'p',
        children: [
          'To illustrate their process they will talk about the making of the Volkswagen office chair, an electric vehicle that goes 19 kmh with a 12 km range. They will also speak about the making of a marble computer for a Paris museum.',
        ],
      },
    ],
    location: {
      address: [{ tag: 'p', children: ['Torggata 15'] }],
      nameOfLocation: `Blank`,
    },
    main: [
      {
        tag: 'p',
        children: [
          'Hakimaki is the design studio / workshop of Martin Gautron and Stian Korntved Ruud undertaking projects from concept to reality. With a process-oriented methodology they make custom objects, installations, machines, models and prototypes for museums, cineasts, architects, and researchers to bring ideas to life.',
        ],
      },
    ],
    program: [
      { description: `Croissanter og kaffe`, time: `08:00` },
      { description: `Presentation: From idea to object`, time: `08:30` },
      { description: `Q&A`, time: `09:15` },
      { description: `Mer kaffe?`, time: `09:30` },
      { description: `Dørene lukkes`, time: `10:00` },
    ],
    signup: {
      url: `https://www.eventbrite.com/e/kjregar-008-from-idea-to-object-tickets-796758454987`,
      opens: `2024-01-17T09:09:00.000Z`,
    },
    speakers: [
      {
        name: `Martin Gautron`,
        roles: null,
        speakerImage: {
          path: '/public/val/images/4b82fae4e99bade4c324455d30b7efe087a2e1b1-4006x2246.webp',
          width: 4006,
          height: 2246,
          mimeType: 'image/webp',
        },
      },
      {
        name: `Stian Korntved Ruud`,
        roles: null,
        speakerImage: {
          path: '/public/val/images/4b82fae4e99bade4c324455d30b7efe087a2e1b1-4006x2246.webp',
          width: 4006,
          height: 2246,
          mimeType: 'image/webp',
        },
      },
    ],
    title: `Hakimaki: From idea to object`,
    typeformId: null,
    eventbriteEventId: null,
    eventbriteUrl: null,
    metadataDescription: `Hakimaki will show how they work from idea to object when making inventions and set pieces in the intersection of design, art and technology.

To illustrate their process they will talk about the making of the Volkswagen office chair, an electric vehicle that goes 19 kmh with a 12 km range. They will also speak about the making of a marble computer for a Paris museum.

(The presentation will be given in english)`,
    metadataTitle: `Hakimaki: From idea to object`,
  },
  '/events/ai-act': {
    date: '2024-08-23T06:00:00.000Z',
    type: 'presentation',
    main: [
      {
        tag: 'p',
        children: [
          'Christoffer Johnsen er senioradvokat hos Ræder Bing, og bistår en rekke virksomheter med å navigere komplekse regulatoriske landskap knyttet til digital innovasjon. Christoffer er en ettertraktet foredragsholder på konferanser og underviser jevnlig på Universitetet i Oslo og Høyskolen Kristiania.',
        ],
      },
    ],
    title: 'Intro til AI Act',
    program: [
      { description: `Croissanter og kaffe`, time: `08:00` },
      { description: `Foredrag: Intro til AI Act`, time: `08:30` },
      { description: `Q&A`, time: `09:15` },
      { description: `Mer kaffe?`, time: `09:30` },
      { description: `Dørene lukkes`, time: `10:00` },
    ],
    location: {
      address: [{ tag: 'p', children: ['Torggata 15, 0181 Oslo'] }],
      nameOfLocation: 'Blank',
    },
    speakers: [
      {
        name: 'Christoffer Johnsen',
        roles: ['Senioradvokat'],
        speakerImage: {
          path: '/public/val/cjo_56e9e.jpg',
          width: 570,
          height: 392,
          mimeType: 'image/jpeg',
        },
      },
    ],
    eventFull: false,
    eventImage: {
      path: '/public/val/eu-ai-act-title-1200x686_ce141.png',
      width: 1200,
      height: 686,
      mimeType: 'image/png',
    },
    signup: {
      url: 'https://www.eventbrite.com/e/kjregar-009-intro-til-ai-act-tickets-988610228807',
      opens: null,
    },
    typeformId: null,
    introduction: [
      {
        tag: 'p',
        children: [
          'I dette foredraget vil Christoffer Johnsen gi en oversikt over AI Act, EUs kommende regulering for kunstig intelligens. Han vil dekke de viktigste aspektene av den nye lovgivningen, inkludert klassifisering av ulike AI-systemer, samt hvordan virksomheter kan forberede seg på å etterleve de nye reglene. Christoffer vil også dele praktiske eksempler for å gjøre de nye kravene forståelige og anvendelige i praksis.',
        ],
      },
    ],
    eventbriteUrl: null,
    metadataTitle: null,
    eventbriteEventId: null,
    metadataDescription: null,
  },
  '/events/lavthengende-ai-frukter': {
    date: '2024-11-08T07:00:00.000Z',
    type: 'presentation',
    main: [],
    title: 'Lavthengende AI-frukter med HMF og BI',
    program: [
      { time: '08:00', description: 'Croissanter og kaffe' },
      { time: '08:30', description: 'Foredrag: Lavthengende AI-frukter' },
      { time: '09:15', description: 'Q&A' },
      { time: '09:30', description: 'Mer kaffe?' },
      { time: '10:00', description: 'Dørene lukkes' },
    ],
    location: {
      address: [{ tag: 'p', children: ['Torggata 15, 0181 Oslo'] }],
      nameOfLocation: 'Blank',
    },
    speakers: [
      {
        name: 'Kim Midtlid',
        roles: [
          'Kim jobber som fullstack-utvikler i Blank, og har i år hjulpet Handelens Miljøfond å gjøre internsystemer bedre ved hjelpe av AI.',
        ],
        speakerImage: {
          path: '/public/val/kim_23101.webp',
          width: 2048,
          height: 1365,
          mimeType: 'image/webp',
        },
      },
      {
        name: 'Ole Jacob Syrdahl',
        roles: [
          'Ole Jacob er fagsjef for teknologi i Blank og har jobbet som fullstack-utvikler i over 15 år.  Denne høsten jobber han i web-teamet hos Handelshøyskolen BI der han har ansvaret for drive frem bruk av AI i skreddersømsprosjekter.',
        ],
        speakerImage: {
          path: '/public/val/oj_23de3.webp',
          width: 800,
          height: 450,
          mimeType: 'image/webp',
        },
      },
      {
        name: 'Sjur Kvifte Nesheim',
        roles: [
          'Sjur er samfunnsviter og fagansvarlig for analyse i Handelens Miljøfond hvor han lager grunnlag for fondets prioriteringer. Han leder også arbeidet med å integrere AI i fondets arbeidsprosesser.',
        ],
        speakerImage: {
          path: '/public/val/sjur_48eba.jpg',
          width: 768,
          height: 576,
          mimeType: 'image/jpeg',
        },
      },
      {
        name: 'Fredrik Hornkjøl Bø',
        roles: [
          'Fredrik jobber som forretningsutvikler for digitale tjenester for studentene på BI. Dette omfatter spekteret fra Studentportalen og læringsteknologien studentene bruker.',
        ],
        speakerImage: {
          path: '/public/val/fredrik_4b9ad.jpg',
          width: 1500,
          height: 1500,
          mimeType: 'image/jpeg',
        },
      },
    ],
    eventFull: false,
    eventImage: {
      path: '/public/val/images/serene-orchad-sunlight.webp',
      width: 2048,
      height: 2048,
      mimeType: 'image/webp',
    },
    signup: { url: 'https://lu.ma/nnjytayj', opens: null },
    typeformId: null,
    introduction: [
      {
        tag: 'p',
        children: [
          'Fredag 8. november får vi besøk av Sjur fra Handelens Miljøfond og Fredrik fra Handelshøyskolen BI,  som forteller oss om hvordan de (sammen med Blank) har angrepet AI-elefanten i sine organisasjoner.',
        ],
      },
      {
        tag: 'p',
        children: [
          'Det blir eksempler på hvordan HMF har brukt AI til å forbedre interne applikasjoner, for å gjøre saksbehandlingen mer effektiv, og noen “lessons learned” fra utviklingsprosjektene.',
        ],
      },
      {
        tag: 'p',
        children: [
          'Hos BI spiller vi på hele spekteret fra enkel klassifisering og semantisk søk til hvordan AI-agenter sammen driver forretningskritiske prosesser fremover.',
        ],
      },
      {
        tag: 'p',
        children: [
          'Vi viser frem produksjonsatte løsninger, samt interne eksperimenter vi jobber med for å lære. Håper du får inspirasjon og konkrete tips til hvordan du kan henge med på AI-kjøret.',
        ],
      },
    ],
    eventbriteUrl: null,
    metadataTitle: null,
    eventbriteEventId: null,
    metadataDescription: null,
  },
  '/events/an-introduction-to-ai-summary': {
    date: '2026-04-17T06:00:00.000Z',
    main: [],
    type: 'presentation',
    title: 'The 1% Problem: An Introduction to AI Security',
    program: [
      { time: '08:00', description: 'Croissanter og kaffe' },
      {
        time: '08:30',
        description: 'Foredrag: The 1% Problem: An Introduction to AI Security',
      },
      { time: '09:15', description: 'Q&A' },
      { time: '09:30', description: 'Mer kaffe?' },
      { time: '10:00', description: 'Dørene lukkes' },
    ],
    location: {
      address: [{ tag: 'p', children: ['Torggata 15, 0181 Oslo'] }],
      nameOfLocation: 'Blank',
    },
    speakers: [
      {
        name: 'Lars Smeby',
        roles: ['Utvikler i Blank'],
        speakerImage: {
          path: '/public/val/smeby2_1e0bf.webp',
          width: 1200,
          height: 800,
          mimeType: 'image/webp',
        },
      },
    ],
    eventFull: false,
    eventImage: {
      path: '/public/val/kjregar_dd3b0.png',
      width: 1600,
      height: 1600,
      mimeType: 'image/png',
    },
    signup: { url: 'https://luma.com/wqx83b0j', opens: '2026-03-30' },
    typeformId: null,
    introduction: [
      {
        tag: 'p',
        children: [
          'Fredag 17. april holder Lars Smeby fra Blank foredraget',
          {
            tag: 'span',
            styles: ['italic'],
            children: ['The 1% Problem: An Introduction to AI Security'],
          },
          ' i Blanks foredragsserie Kjøregår.',
        ],
      },
      { tag: 'p', children: [] },
      {
        tag: 'p',
        children: [
          {
            tag: 'a',
            href: 'https://luma.com/wqx83b0j',
            children: ['Meld deg på her'],
          },
          { tag: 'br' },
        ],
      },
      {
        tag: 'p',
        children: [
          'Vi bygger alle med AI - men hvor godt forstår vi egentlig risikoen? I dette foredraget får du en introduksjon til hvordan språkmodeller kan manipuleres, hvorfor angrep ikke kan elimineres helt, og hva du kan gjøre for å redusere konsekvensene.',
          { tag: 'br' },
        ],
      },
      {
        tag: 'p',
        children: [
          'Lars Smeby jobber som utvikler i Blank, noe han har gjort siden 2016. Han har blant annet erfaring fra kunder som ice, Morgenlevering og Autodesk.',
          { tag: 'br' },
          { tag: 'br' },
          'Foredraget vil foregå på ',
          { tag: 'span', styles: ['bold'], children: ['engelsk. '] },
          { tag: 'br' },
        ],
      },
      {
        tag: 'p',
        children: [
          {
            tag: 'span',
            styles: ['italic'],
            children: ['The 1% Problem: An Introduction to AI Security'],
          },
          ' er den ellevte i kjøregårserien til Blank.',
        ],
      },
      { tag: 'p', children: [] },
      {
        tag: 'p',
        children: [
          {
            tag: 'a',
            href: 'https://luma.com/wqx83b0j',
            children: ['Meld deg på her'],
          },
        ],
      },
    ],
    eventbriteUrl: null,
    metadataTitle: 'The 1% Problem: En introduksjon til AI-sikkerhet | Blank',
    eventbriteEventId: null,
    metadataDescription:
      'Bli med på “The 1% Problem: En introduksjon til AI-sikkerhet” med Lars Smeby hos Blank. Lær hvordan AI-systemer kan utnyttes, hvorfor risiko ikke kan fjernes helt, og hvordan du bygger tryggere løsninger.',
  },
  '/events/studentfest-2024': {
    date: `2024-06-25T15:00:00.000Z`,
    type: 'party',
    eventFull: true,
    eventImage: {
      path: `/public/val/studentfest_2024_af4e0.webp`,
      width: 3750,
      height: 1875,
      mimeType: `image/webp`,
    },
    introduction: [
      {
        tag: 'p',
        children: [
          'Vi inviterer dere som studerer teknologi eller design til å besøke oss på loftet vårt tirsdag 25. juni 🎉',
        ],
      },
    ],
    location: {
      address: [
        {
          tag: 'p',
          children: [
            {
              tag: 'a',
              href: 'https://goo.gl/maps/GLURauoXQKKWPB9S8',
              children: ['Torggata 15, 0971 Oslo'],
            },
          ],
        },
      ],
      nameOfLocation: `Blank`,
    },
    main: [
      {
        tag: 'p',
        children: [
          'Vi serverer litt mat klokken 17, og ellers snacks og valgfri drikke hele kvelden.\n    Meld deg på via skjemaet her på siden.\n    ',
          '\n    Velkommen til oss!\n    ',
          '\n    PS: Alle studenter er invitert, og ta gjerne med en venn, uvenn eller kollega hvis du vil det.',
        ],
      },
    ],
    program: [
      { description: `Dørene åpnes`, time: `17:00` },
      { description: `Dørene lukkes`, time: `23:59` },
    ],
    signup: null,
    typeformId: `nIbBBdaD`,
    speakers: [],
    title: `Studentfest 2024`,
    eventbriteEventId: null,
    eventbriteUrl: null,
    metadataDescription:
      'Vi inviterer dere som studerer teknologi eller design til å besøke oss på loftet vårt tirsdag 25. juni 🎉',
    metadataTitle: `Studentfest 2024`,
  },
  '/events/slutt-aa-lete-etter-gode-ideer': {
    date: '2026-09-04T06:00:00.000Z',
    main: [{ tag: 'p', children: [] }],
    type: 'presentation',
    title: 'Slutt å lete etter gode ideer',
    signup: { url: 'https://luma.com/anlyv2j8', opens: '2026-08-12' },
    program: [
      { time: '08:00', description: 'Croissanter og kaffe' },
      { time: '08:30', description: 'Foredrag: Slutt å lete etter gode ideer' },
      { time: '09:15', description: 'Q&A' },
      { time: '09:30', description: 'Mer kaffe?' },
      { time: '10:00', description: 'Dørene lukkes' },
    ],
    location: {
      address: [{ tag: 'p', children: ['Torggata 15, 0181 Oslo'] }],
      nameOfLocation: 'Blank',
    },
    speakers: [
      {
        name: 'Nima Shahinian',
        roles: ['Kreativ problemløser, designer og konseptutvikler'],
        speakerImage: {
          path: '/public/val/nima-profilbilde-farger_1200px_01ff3.jpg',
          width: 1200,
          height: 1062,
          mimeType: 'image/jpeg',
        },
      },
    ],
    eventFull: false,
    eventImage: {
      path: '/public/val/history-in-hd-e5edhbmhprg-unsplash_ce6ae.jpg',
      alt: 'Apollo 11 astronaut Buzz Aldrin walks on the surface of the moon on July 20, 1969, in a photograph taken by Neil Armstrong.',
      width: 2662,
      height: 3697,
      mimeType: 'image/jpeg',
    },
    typeformId: null,
    introduction: [
      {
        tag: 'p',
        children: [
          'Fredag 4. september holder Nima Shahinian foredraget "Slutt å lete etter gode ideer" i Blanks foredragsserie Kjøregår.',
        ],
      },
      {
        tag: 'p',
        children: [
          {
            tag: 'a',
            href: 'https://luma.com/anlyv2j8',
            children: ['Meld deg på her'],
          },
          { tag: 'br' },
          { tag: 'br' },
          'Nima er produktdesigner, konseptutvikler og grunnlegger av Nåva Space, hvor han også har rollen som Chief Architect. Kreativitet er kjernen i hans faglige virke, og gjennom mange år har han arbeidet som rådgiver og mentor innen kreative prosesser, innovasjon og problemløsning. Han hjelper både studenter, virksomheter og organisasjoner med å utfordre etablerte sannheter, se nye muligheter og omsette ambisiøse ideer til virkelighet.',
        ],
      },
      {
        tag: 'p',
        children: [
          '​Som Norges første trente kommersielle astronautkandidat representerer Nima en sjelden kombinasjon av designer, teknolog, utforsker og visjonær. Han arbeider ikke bare med verdensrommet- han arbeider med hvordan vi kan tenke større om menneskets fremtid. Hans sterke engasjement for innovasjon, teknologi og bærekraft har formet hans filosofi rundt ledelse, samarbeid og design, med en grunnleggende tro på at de største fremskrittene begynner med viljen til å utfordre det som tilsynelatende er umulig.',
          { tag: 'br' },
          { tag: 'br' },
          'Dette foredraget fokuserer på veien til gode ideer ved å ikke lete etter gode ideer, men heller gode problemstillinger.',
          { tag: 'br' },
          { tag: 'br' },
          'Foredraget vil foregå på ',
          { tag: 'span', styles: ['bold'], children: ['norsk.'] },
        ],
      },
      {
        tag: 'p',
        children: [
          ' ',
          {
            tag: 'span',
            styles: ['italic'],
            children: ['Slutt å lete etter gode ideer'],
          },
          ' er den tolvte serien i kjøregårserien til Blank.',
        ],
      },
      {
        tag: 'p',
        children: [
          {
            tag: 'a',
            href: 'https://luma.com/anlyv2j8',
            children: ['Meld deg på her'],
          },
        ],
      },
    ],
    eventbriteUrl: null,
    metadataTitle: '"Slutt å lete etter gode ideer"',
    eventbriteEventId: null,
    metadataDescription:
      'Bli med på "Slutt å lete etter gode ideer" med Nima Shahinian den 4.september hos blank',
  },
  '/events/en-psykologs-moete-med-kunstig-intelligens': {
    date: '2026-10-23T06:00:00.000Z',
    main: [{ tag: 'p', children: [] }],
    type: 'presentation',
    title: 'En psykologs møte med kunstig intelligens',
    signup: { url: 'https://luma.com/6gixk0q8', opens: '2026-09-24' },
    program: [
      { time: '08:00', description: 'Croissanter og kaffe' },
      {
        time: '08:30',
        description: 'Foredrag: En psykologs møte med kunstig intelligens',
      },
      { time: '09:15', description: 'Q&A' },
      { time: '09:30', description: 'Mer kaffe?' },
      { time: '10:00', description: 'Dørene lukkes' },
    ],
    location: {
      address: [{ tag: 'p', children: ['Torggata 15, 0181 Oslo'] }],
      nameOfLocation: 'Blank',
    },
    speakers: [
      {
        name: 'Jan Ketil Arnulf',
        roles: [
          'Professor i organisasjonspsykologi ved Handelshøyskolen BI og professor II ved Forsvarets Høgskole',
        ],
        speakerImage: {
          path: '/public/val/901c6bbf-929f-401a-9655-7c681d5460e8_04c47.jpg',
          width: 720,
          height: 660,
          mimeType: 'image/jpeg',
        },
      },
    ],
    eventFull: false,
    eventImage: {
      path: '/public/val/growtika-ngocbxiaro0-unsplash_4fadc.jpg',
      width: 1920,
      height: 1080,
      mimeType: 'image/jpeg',
      alt: 'A brain represented by small light diodes',
    },
    typeformId: null,
    introduction: [
      {
        tag: 'p',
        children: [
          'Fredag 23. oktober vil Jan Ketil Arnulf holde foredraget "En psykologs møte med kunstig intelligens" i Blanks foredragsserie Kjøregår.',
          { tag: 'br' },
          { tag: 'br' },
          {
            tag: 'a',
            href: 'https://luma.com/6gixk0q8',
            children: ['Meld deg på her'],
          },
          { tag: 'br' },
          { tag: 'br' },
          'Jan Ketil Arnulf er professor i organisasjonspsykologi ved Handelshøyskolen BI og professor II ved Forsvarets Høgskole. Han har forsket på, praktisert og lidd under sammenhengen mellom språk, digitalisering og ledelse i flere tiår. I 2025 ga han ut boken "Kunstig intelligent psykologi" – som tok for seg blant annet hvordan maskiner lærer seg å snakke, hvordan dette henger sammen med menneskers språk, og hva det betyr for organisasjoner og ledelse.',
        ],
      },
      {
        tag: 'p',
        children: [
          '​Utviklingen og bruken av AI har økt vanvittig bare siden boken ble skrevet. Jan Ketil tar oss med på hvordan hans eget syn på kunstig intelligens har endret seg, og forklarer hva språk egentlig betyr for oss mennesker – og hva som skjer når vi nå snakker mer og mer med maskiner.',
          { tag: 'br' },
          'Mister vi tilliten til oss selv? Hvordan kan vi vinne den tilbake?',
        ],
      },
      {
        tag: 'p',
        children: [
          '​Og hva er egentlig AI-fatigue – denne snikende utmattelsen av å alltid følge med, dobbeltsjekke og henge med i svingene? Hvordan kan både du og lederen din forhindre det – gjennom å forstå teknologien bedre, eller gjennom å forstå hjernen bedre?',
        ],
      },
      {
        tag: 'p',
        children: [
          '​Dette frokostforedraget vil handle om AI – som så mye annet gjør i dag – men denne gangen vil det handle like mye om oss.',
        ],
      },
      {
        tag: 'p',
        children: [
          '​Foredraget vil foregå på ',
          { tag: 'span', styles: ['bold'], children: ['norsk.'] },
        ],
      },
      {
        tag: 'p',
        children: [
          '​',
          {
            tag: 'span',
            styles: ['italic'],
            children: ['En psykologs møte med kunstig intelligens'],
          },
          ' er den trettende serien i kjøregårserien til Blank.',
          { tag: 'br' },
          { tag: 'br' },
          {
            tag: 'a',
            href: 'https://luma.com/6gixk0q8',
            children: ['Meld deg på her'],
          },
        ],
      },
    ],
    eventbriteUrl: null,
    metadataTitle: '"En psykologs møte med kunstig intelligens"',
    eventbriteEventId: null,
    metadataDescription:
      'Bli med på "En psykologs møte med kunstig intelligens" med Jan Ketil Arnulf den 23. oktober hos Blank',
  },
});
